import * as MedicalHistoryService from "../../../services/MedicalHistoryService";
import useResource from "../../../hooks/UseResource";

export default function useLatestMedicalHistoryForPatient(patientId) {
    return useResource(patientId, MedicalHistoryService.getLatestMedicalHistoryForPatient);
}
